export const availabilityTagTypes = {
  ALPHA: "alpha",
  BETA: "beta",
  GA: "ga",
  HIDDEN: "hidden",
};

export const visibleAvailabilityTags = [
  availabilityTagTypes.ALPHA,
  availabilityTagTypes.BETA,
];

export const DESKTOP_ONLY_APP_CODES = ["coder_chat", "coder"];

export const DESKTOP_APP_AGENT_TYPES = {
  coder_chat: "coder",
};

export const EXTERNAL_APP_URLS = {
  android_app: "https://play.google.com/store/apps/details?id=com.sugeragi.chat",
  ios_app: "https://apps.apple.com/in/app/superagi/id6667110955",
  chrome_plugin: "https://chromewebstore.google.com/detail/superagi-free-linkedin-em/efddnnnikgkbfilkoldcbgpaiknfbgol?hl=en",
};
